var _circle, _path, _rect, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 32,
    viewBox: "0 0 224 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#323539"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 16.833L13.5013 20.1663L21.8346 11.833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 15,
    width: 80,
    height: 2,
    fill: "#121212"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 16,
    r: 15,
    stroke: "#323539",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 16,
    r: 5,
    fill: "#323539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.012088defa62dceebd40029a7e45f47c.svg";
export { ForwardRef as ReactComponent };